import { useCallback, useState } from "react";
import { useApi } from "../apiCall/useApi";
import Joi from "joi";
import { Urls } from "../../../utils/constant";
import { size } from "lodash";
import { useSnackbar } from "notistack";
import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";
import { useDispatch } from "react-redux";
import Api from "../../../utils/api.utils";
import useFullPageLoader from "../Common/PageLoader/useFullPageLoader";
import { setLeaveData } from "../../reducers/Leave/leaveForm.reducer";

export const LeaveEntrySchema = Joi.object({
  leave_type: Joi.string().required().messages({
    "string.empty": "Leave Type is required.",
  }),
});

export function useLeaveForm({ existingStatus }) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [status, setStatus] = useState(existingStatus === 2 ? 0 : 1);
  const [Id, setId] = useState("");
  const [Name, setName] = useState("");

  const handleDeleteId = useCallback(
    (row) => {
      setId(row.id);
      setName(row.leave_type);
    },
    [Id, Name]
  );

  const LeaveEntry = useCallback(
    async ({ leave_type }) => {
      const status_Val = status === false ? 2 : status === 0 ? 2 : 1;
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());
        // const formattedReportDate = format(ReportDate, 'yyyy-MM-dd');
        const { data } = await apiPost({
          url: Urls.leaveAdd(),
          data: {
            leave_type: leave_type,
            status: status_Val,
            insert_by: "",
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        if (data && data.id && data.id.length === 36) {
          // Adjust condition if necessary
          enqueueSnackbar("Leave Data Added Successfully.", {
            variant: "success",
          });
          return true;
        }

        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [status, loading]
  );

  const LeaveUpdate = useCallback(
    async ({ id, leave_type }) => {
      if (loading) return;
      setLoading(true);
      const status_Val = status === false ? 2 : status === 0 ? 2 : 1;
      try {
        dispatch(showPageLoader());
        const { data } = await apiPost({
          url: Urls.leaveUpdate(),
          data: {
            id: id,
            leave_type: leave_type,
            status: status_Val,
            update_by: "",
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        if (size(data.id) === 36) {
          enqueueSnackbar("Leave Data Updated Successfully.", {
            variant: "success",
          });
          return true;
        }

        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [status, loading]
  );

  const leaveDelete = useCallback(async () => {
    //   const formattedReportDate = format(ReportDate, 'yyyy-MM-dd');
    try {
      dispatch(showPageLoader());
      const { data } = await apiPost({
        url: Urls.leaveUpdate(),
        data: {
          id: Id,
          leave_type: Name,
          status: 2,
          update_by: "",
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (size(data.id) === 36) {
        enqueueSnackbar("Leave Data Deleted Successfully.", {
          variant: "success",
        });
        return true;
      }

      setLoading(false);
      dispatch(hidePageLoader());
    } catch (err) {
      dispatch(hidePageLoader());
      console.log(err);
      setLoading(false);
      return false;
    }
  }, [status, Id, Name]);

  const getLeaveById = useCallback(
    async (id) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());

        const { data } = await apiPost({
          url: Urls.getLeaveById(),
          data: {
            id: id,
          },
        });

        dispatch(setLeaveData(data));
        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [loading]
  );

  const handleStatusComboChange = useCallback((event) => {
    if (event.target.checked === 1) {
      setStatus(event.target.checked);
    } else {
      setStatus(event.target.checked);
    }
  }, []);

  return {
    loader,
    loading,
    status,
    LeaveEntrySchema,
    handleStatusComboChange,
    LeaveEntry,
    LeaveUpdate,
    getLeaveById,
    leaveDelete,
    handleDeleteId,
  };
}
